const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const repeat = async <T>(
  fn: (stop: () => void) => T | Promise<T>,
  times = 10,
  delay = 1000,
) => {
  let shouldStop = false;
  const stop = () => (shouldStop = true);
  let result: T | undefined;
  for (let n = 0; n < times; n++) {
    result = await fn(stop);
    if (shouldStop) {
      break;
    }
    await sleep(delay);
  }
  return result;
};

export type RetryWithBackoffOptions = {
  retries?: number;
  baseDelayMs?: number;
};

export const retryWithBackoff = async <T>(
  fn: () => Promise<T>,
  { retries = 3, baseDelayMs = 500 }: RetryWithBackoffOptions = {},
): Promise<T> => {
  for (let attempt = 0; ; attempt++) {
    try {
      return await fn();
    } catch (error) {
      if (attempt >= retries) {
        throw error;
      }
      await sleep(baseDelayMs * 2 ** attempt);
    }
  }
};
